<template>
  <b-col md="3" sm="3" xl="3" class="text-center animated fadeIn fadeOut">
    <b-card :bg-variant="has_online ? (wsf.is_row ? 'danger' : 'success') : 'gray'" @click="detail(wsf)" :style="{ cursor: 'pointer'}">
      <!-- <h6><strong>{{wsf.name || '-'}}</strong></h6> -->
      <!-- <h6>{{wsf.host}}@{{wsf.ip_addr}}<br></h6> -->
      <!-- <b-badge variant="success" v-if="!wsf.ms == 0 ">Online ({{wsf.ms}} ms)</b-badge> -->
      <b-badge variant="light" style="min-width: 100px; max-width: 130px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap;">{{wsf.name}}</b-badge>
    </b-card>
  </b-col>
</template>

<script>
export default {
  props: ['wsf', 'wsf_pong_list'],
  computed: {
    has_online() { return (this.wsf_pong_list || []).indexOf(this.wsf.agent_id) > -1 }
  },
  methods: { detail: function(wsf) { this.$router.push({ name :  'wsfinder_agent', params : { id : wsf.agent_id } }); }, },
  created () { console.info('wsfinder-agent-item.vue created') },
  destroyed () { console.log('wsfinder-agent-item.vue destroyed') },
  mounted () {  console.log('wsfinder-agent-item.vue mounted'); this.$forceUpdate(); },
}
</script>
